import { Select } from '@bfe/moly';
import { message } from 'antd';
import React, { FC, useEffect, useState } from 'react';

import CurrencyOfflineModal from '@/components/CurrencyOfflineModal';
import useCurrency from '@/hooks/useCurrency';
import { useErrorMsg } from '@/hooks/useErrorMsg';
import { useI18nContext } from '@/i18n/I18n';
import { setCurrencyCode } from '@/services/setting';
import { UserInfo } from '@/services/types/common';
import { useStore } from '@/store/useStore';
import { $tracing } from '@/utils/tracing';

const Coin = () => {
  const [$t] = useI18nContext();
  // const { profile: user, mutate } = useUserProfile();
  const { userInfo: user, mutateUserInfo } = useStore();
  const { msgError } = useErrorMsg(mutateUserInfo);
  const [currentCurrency, setCurrentCurrency] = useState('');

  const { currencyList, showCurrencyOfflineModal, checkUserCurrencyCode } =
    useCurrency();

  const updateUserByMutate = (obj: UserInfo) => {
    mutateUserInfo((profile: any) => {
      if (profile?.result) profile.result = obj;
      return profile;
    });
  };

  const currencyChange = (currency_code: any) => {
    setCurrencyCode(currency_code)
      .then(() => {
        // 更新userInfo信息
        const obj = {
          ...user,
          currency_code,
        } as UserInfo;
        // 更新用户信息
        updateUserByMutate(obj);
        // 上报埋点
        $tracing.addEvent({
          t: 'action',
          c: 15106,
          m: `currency:${currency_code}`,
        });
        message.success({
          content: $t('SUccess'),
        });
      })
      .catch((error) => {
        msgError(error);
      });
  };

  useEffect(() => {
    if (user?.currency_code) {
      checkUserCurrencyCode(user?.currency_code)?.then((res) => {
        if (res?.is_offline === 1) {
          setCurrentCurrency('');
        } else {
          setCurrentCurrency(user?.currency_code || '');
        }
      });
    }
  }, [user]);

  let options: any[] = [];

  if (currencyList.length > 0) {
    options = currencyList.map((item) => {
      return {
        label: $t(`currencies.${item.code}`) + '  ' + item.code,
        value: item.code,
      };
    });
  }

  return (
    <>
      <div className="coin-container">
        <div className="coin-setup-form">
          <div className="coin-setup-form-title">{$t('Coin')}</div>

          <div className="coin-setup-form-label">
            {$t('Equivalent Currency')}
          </div>
          <div className="coin-setup-form-item">
            <Select
              width={480}
              placeholder={$t('Please Select')}
              virtual={false}
              value={currentCurrency}
              options={options}
              onChange={currencyChange}
              showSearch
            ></Select>
          </div>
        </div>
      </div>
      <CurrencyOfflineModal code={showCurrencyOfflineModal} />
    </>
  );
};

export default Coin;
